export enum PricingSurchargeCalculationType {
  None = 'none',
  Surcharge = 'surcharge',
  LineItem = 'line-item-surcharge',
}
